var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProbationExtension(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9243",
    "data-name": "Group 9243",
    transform: "translate(-14259 -9096)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1803",
    "data-name": "Ellipse 1803",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(14259 9096)",
    fill: "#d34a7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bxs-user-check",
    d: "M12.134,18.133a5.187,5.187,0,0,0,5.328-5.278,5.187,5.187,0,0,0-5.328-5.278,5.187,5.187,0,0,0-5.328,5.278A5.187,5.187,0,0,0,12.134,18.133Zm1.522,1.429H10.612A7.584,7.584,0,0,0,3,27.1V28.61H21.269V27.1A7.584,7.584,0,0,0,13.657,19.563Z",
    transform: "translate(14274.999 9105.422)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProbationExtension);
export default __webpack_public_path__ + "static/media/probation-extension.476dfd9d47202afcec2aeddb117940e9.svg";
export { ForwardRef as ReactComponent };